export default __webpack_public_path__ + "static/media/calendar.68fa4675.svg";